import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/Results/Results.js";
const variants = import.meta.webpackContext("/components/Results", { recursive: true, regExp: /\.\/__variants__\/plp\-curated\-category\-treatments\/allSizes\/Results\.js/ });
export default pointCut({ joinPoint, variants });